import * as streamActions from '../store/actions/InterviewRecordingActions';

const totalTimer = data =>
  (data.total_time > 0
    ? data.total_time
    : data.sections_info?.reduce((sum, sec) => sec.total_time + sum, 0)) || 0;

export const sectionInfoSerializer = data => {
  return {
    loading: false,
    title: data.title || '',
    instructions: data.instructions || '',
    totalTime: totalTimer(data),
    totalProblems: data.total_problems || 0,
    totalMcqs: data.total_mcqs || 0,
  };
};

export const leaveMeeting = async (meetingSession, dispatch) => {
  if (!meetingSession) return;

  try {
    const { audioVideo } = meetingSession;

    if (audioVideo.stopVideoInput) {
      await audioVideo.stopVideoInput();
    }

    if (audioVideo.stopAudioInput) {
      await audioVideo.stopAudioInput();
    }

    try {
      await audioVideo.stopContentShare();
    } catch (err) {
      console.warn('[Chime] Content share cleanup skipped:', err);
    }

    audioVideo.stop();

    if (audioVideo.realtimeUnsubscribeFromAllEvents) {
      audioVideo.realtimeUnsubscribeFromAllEvents();
    }

    dispatch(streamActions.stopAllStreams());
    console.log('Left meeting and cleaned up');
  } catch (err) {
    console.error('Error while leaving meeting:', err);
  }
};
